"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgCloudOff = function SvgCloudOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.707 12.293l22 22a1 1 0 01-1.414 1.414l-2.88-2.877c-.461.112-.935.17-1.413.17h-8.984a9 9 0 01-5.594-16.163l-3.13-3.13a1 1 0 011.415-1.414zm.4 13.512A7.005 7.005 0 0021 31h8.585L16.853 18.269a7 7 0 00-2.746 7.536zm7.671-10.801A9 9 0 0129.482 21H30a6 6 0 015.532 8.34 1 1 0 01-1.842-.78A4 4 0 0030 23h-1.26a1 1 0 01-.97-.754 7 7 0 00-6.168-5.25 1 1 0 11.176-1.992z",
    id: "cloud-off_svg__a"
  }));
};

var _default = SvgCloudOff;
exports["default"] = _default;